import React from 'react';
import { Link } from 'gatsby';

import './page-banner.styles.scss';

type PageBannerProps = {
  pageTitle: string;
  homePageUrl: string;
  homePageText: string;
  activePageText: string;
};

const PageBanner: React.FC<PageBannerProps> = ({
  pageTitle,
  homePageUrl,
  homePageText,
  activePageText,
}) => {
  return (
    <div className="page-title">
      <div className="container">
        <div className="page-title-content">
          <h2>{pageTitle}</h2>
          <ul>
            <li>
              <Link to={homePageUrl}>{homePageText}</Link>
            </li>
            <li>{activePageText}</li>
          </ul>
        </div>
      </div>

      <div className="floaticon1">
        <img
          src={require('../../assets/photos/floaticons/floaticon1.png')}
          alt="banner"
        />
      </div>
      <div className="floaticon2">
        <img
          src={require('../../assets/photos/floaticons/floaticon2.png')}
          alt="banner"
        />
      </div>
      <div className="floaticon3">
        <img
          src={require('../../assets/photos/floaticons/floaticon3.png')}
          alt="banner"
        />
      </div>
    </div>
  );
};

export default PageBanner;
